import React from "react";

import "./BottomBar.css";

export default function BottomBar() {
  return (
    <div className="bottomBar-container">
      <div className="bottomBar-textFont">Pinecone Labs LLC 2025</div>
      <div className="bottomBar-subContainer">
        <a
          className="bottomBar-buttonFont"
          href="mailto:insporecipeapp@gmail.com"
        >
          support
        </a>
        <a className="bottomBar-buttonFont" href="terms">
          terms
        </a>
        <a className="bottomBar-buttonFont" href="privacypolicy">
          privacy
        </a>
      </div>
    </div>
  );
}
